import React from 'react';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import { TableAppRow, TableAppCell } from 'components/IterioApp/components/TableApp';
import Checkbox from '@material-ui/core/Checkbox';

import avatarImg from 'images/console-users/user-avatar-1.svg';
import avatarImg2 from 'images/console-users/user-avatar-2.svg';
import avatarImg3 from 'images/console-users/user-avatar-3.svg';

import { usersConfig } from '../Users.config';
import { TableUsername, TableAvatar, CheckboxWrap } from './UserTableCell.styles';

const avatars = [avatarImg, avatarImg2, avatarImg3];
const styles = {
  tableRow: {
    cursor: 'pointer',
    transition: '0.25s all',

    '&:hover': {
      textDecoration: 'underline',
      color: '#00bbf4',
    },
  },
  checkboxTd: {
    border: 'none!important',
  },
};

const UserTableCell = (props) => {
  const { user, selectedUsers, handleSelectUser, handleSelectUsers, classes } = props;

  const onClick = () => {
    handleSelectUser(user.user_id);
  };

  const onCheckboxClick = () => {
    handleSelectUsers(user.user_id);
  };

  const renderCell = (userData, name, type) => {
    const value = userData[name] || null;

    switch (type) {
      case 'username':
        return renderUsername(value, name);
      case 'fromNow':
        return renderFromTime(value, name);
      case 'checkbox':
        return renderCheckbox(name);
      default:
        return <TableAppCell key={name}>{value}</TableAppCell>;
    }
  };

  const renderUsername = (value, name) => {
    return (
      <TableAppCell
        key={name}
        className={classes.tableRow}
        onClick={onClick}
      >
        <TableUsername>
          <TableAvatar>
            <img src={getAvatar(value)} alt="avatar" />
          </TableAvatar>

          {value}
        </TableUsername>
      </TableAppCell>
    );
  };

  const getAvatar = (user_id) => {
    const numberId = String(user_id).replace(/\D+/gm, '');
    const intId = parseInt(numberId, 10);
    const avatarIndex = intId % 3;
    return avatars[avatarIndex];
  };

  const renderFromTime = (value, name) => {
    return (
      <TableAppCell key={name}>
        {moment.utc(value).format('YYYY-MM-DD HH:mm:ss')}
      </TableAppCell>
    );
  };

  const renderCheckbox = (name) => {
    const isChecked = !!selectedUsers.includes(user.user_id);

    return (
      <TableAppCell className={classes.checkboxTd} key={name}>
        <CheckboxWrap>
          <Checkbox color="primary" onClick={onCheckboxClick} checked={isChecked} />
        </CheckboxWrap>
      </TableAppCell>
    );
  };

  return (
    <TableAppRow hover>
      {usersConfig.map(cell => renderCell(user, cell.name, cell.type, classes))}
    </TableAppRow>
  );
};

export default withStyles(styles)(UserTableCell);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/UserTableCell/UserTableCell.jsx